import { TournamentResults } from '../lib/tournaments/components/tournament-results'
import { TournamentStats } from '../lib/tournaments/components/tournament-stats'
import { Replay } from '../lib/replays/components/Replay'
import { register, compose } from 'component-register'
import { withSolid } from 'solid-element'

const withNoShadowDOM = (ComponentType: any) => {
  return (props: any, options: any) => {
    const { element } = options
    Object.defineProperty(element, 'renderRoot', {
      value: element,
    })
    return ComponentType(props, options)
  }
}

compose(register('tournament-results', { tournamentId: 'null' }), withSolid, withNoShadowDOM)(TournamentResults)
compose(register('tournament-stats', { tournamentId: 'null' }), withSolid, withNoShadowDOM)(TournamentStats)
compose(register('build-order', { url: 'null', requireConfirmation: null }), withSolid, withNoShadowDOM)(Replay)
